import { render, staticRenderFns } from "./SchoolCycleGradeEngagementTab.vue?vue&type=template&id=572a6f86"
import script from "./SchoolCycleGradeEngagementTab.vue?vue&type=script&lang=js"
export * from "./SchoolCycleGradeEngagementTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports